import type { Dispatch, SetStateAction } from 'react';
import { ToggleGroup, ToggleGroupItem } from '@savvy-kit/components/toggle-group';

import type { PerformanceTimePeriodName as TimePeriodName } from '@savvy/constants/generated/gql-enums';
import {
  PERFORMANCE_TIME_PERIOD_ALL_TIME,
  PERFORMANCE_TIME_PERIOD_LAST_QUARTER,
  PERFORMANCE_TIME_PERIOD_PAST_MONTH,
  PERFORMANCE_TIME_PERIOD_PAST_THREE_MONTHS,
  PERFORMANCE_TIME_PERIOD_PAST_YEAR,
  PERFORMANCE_TIME_PERIOD_YEAR_TO_DATE,
} from '@savvy/constants/performance-time-periods';
import { mobileToggleColors } from '@savvy/deprecated-shared/theme';

type PortfolioLevelType = 'netWorth' | 'portfolio' | 'account';
export function MobileDateRangeToggle({
  quickDate,
  setQuickDate,
  portfolioLevel,
}: {
  readonly quickDate: TimePeriodName;
  readonly setQuickDate: Dispatch<SetStateAction<TimePeriodName>>;
  readonly portfolioLevel?: PortfolioLevelType;
}) {
  const orderedTimePeriods: TimePeriodName[] = [
    PERFORMANCE_TIME_PERIOD_ALL_TIME,
    PERFORMANCE_TIME_PERIOD_YEAR_TO_DATE,
    PERFORMANCE_TIME_PERIOD_PAST_YEAR,
    PERFORMANCE_TIME_PERIOD_PAST_THREE_MONTHS,
    PERFORMANCE_TIME_PERIOD_PAST_MONTH,
  ];

  const colorTheme = () => {
    switch (portfolioLevel) {
      case 'netWorth':
        return mobileToggleColors.netWorth;
      case 'account':
        return mobileToggleColors.account;
      case undefined:
      case 'portfolio':
      default:
        return mobileToggleColors.portfolio;
    }
  };

  return (
    <div className="flex flex-col items-center pb-6">
      <ToggleGroup
        value={[quickDate]}
        onValueChange={([next]) => {
          const match = orderedTimePeriods.find((period) => period === next);
          if (match) {
            setQuickDate(match);
          }
        }}
        style={{ padding: 5, backgroundColor: colorTheme().background }}
      >
        {orderedTimePeriods.map((timePeriod) => {
          const selected = quickDate === timePeriod;
          return (
            <ToggleGroupItem
              key={timePeriod}
              value={timePeriod}
              style={{
                width: 42,
                height: 29,
                color: colorTheme().text,
                backgroundColor: selected ? colorTheme().active : undefined,
              }}
            >
              {dateRangeToLabel(timePeriod)}
            </ToggleGroupItem>
          );
        })}
      </ToggleGroup>
    </div>
  );
}

const dateRangeToLabel = (dateRange: TimePeriodName) => {
  switch (dateRange) {
    case PERFORMANCE_TIME_PERIOD_ALL_TIME:
      return 'ALL';
    case PERFORMANCE_TIME_PERIOD_YEAR_TO_DATE:
      return 'YTD';
    case PERFORMANCE_TIME_PERIOD_PAST_YEAR:
      return '1Y';
    case PERFORMANCE_TIME_PERIOD_PAST_THREE_MONTHS:
      return '3M';
    case PERFORMANCE_TIME_PERIOD_PAST_MONTH:
      return '1M';
    case PERFORMANCE_TIME_PERIOD_LAST_QUARTER:
    default:
      return dateRange;
  }
};
